// services/FCMService.js - Service Worker pour les notifications push
class FCMService {
  constructor() {
    this.messaging = null;
    this.isSupported = false;
  }

  async initialize() {
    try {
      if ('serviceWorker' in navigator && 'PushManager' in window) {
        // Importer Firebase Messaging
        const { getMessaging, getToken, onMessage } = await import('firebase/messaging');
        
        this.messaging = getMessaging();
        this.isSupported = true;
        
        // Écouter les messages en premier plan
        onMessage(this.messaging, (payload) => {
          console.log('Message reçu en premier plan:', payload);
          this.showNotification(payload);
        });
        
        return true;
      }
      
      return false;
    } catch (error) {
      console.error('Erreur initialisation FCM:', error);
      return false;
    }
  }

  async requestPermission() {
    try {
      const permission = await Notification.requestPermission();
      return permission === 'granted';
    } catch (error) {
      console.error('Erreur demande permission:', error);
      return false;
    }
  }

  async getToken() {
    try {
      if (!this.messaging) {
        await this.initialize();
      }
      
      const { getToken } = await import('firebase/messaging');
      
      const token = await getToken(this.messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY
      });
      
      return token;
    } catch (error) {
      console.error('Erreur récupération token FCM:', error);
      return null;
    }
  }

  showNotification(payload) {
    const { title, body, icon, badge } = payload.notification || {};
    
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.showNotification(title || 'Nouvelle notification', {
          body: body || payload.data?.message,
          icon: icon || '/favicon.ico',
          badge: badge || '/favicon.ico',
          data: payload.data,
          requireInteraction: payload.data?.urgency === 'urgent',
          actions: [
            {
              action: 'view',
              title: 'Voir'
            },
            {
              action: 'dismiss',
              title: 'Ignorer'
            }
          ]
        });
      });
    }
  }
}

export default new FCMService();